<template>
     <div class="dashboard">
      <div class="content">
      <div class="left-column">
        <div class="card raw-coal-production">
          <div class="card-header" style="margin-bottom: 2px;">
            <h2><i class="icon blue"></i> 项目总览</h2>
            <!-- <div class="time-filter">
              <button class="active" @click="selectCenter">切换中心</button>
            </div> -->
          </div>
          <div class="production-data">
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><Calendar />
              </el-icon>   -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#1890ff">
                  <path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14zm-2-2H9v-2h6v2zm0-4H9v-2h6v2zm0-4H9v-2h6v2zm0-4H9v-2h6v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData1["yesterday_pass"]}}</div>
              <div class="data-label">昨日入组(人)</div>
              </div>
            </div>
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><Histogram /></el-icon> -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#52c41a">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData1["month_pass"]}}</div>
              <div class="data-label">当月入组(人)</div>
              </div>
            </div>
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><TrendCharts /></el-icon> -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#ff4d4f">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2zm0-4H7V3h10v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData1["year_pass"]}}</div>
              <div class="data-label">总共入组(人)</div>
              </div>
            </div>
          </div>
          <div ref="passGroupCenterChart" class="card coal-trend" :style="{ width: passGroupCenterChartWidth + 'px',height: '290px'}"></div>
        </div>
        <!-- <div ref="passGroupCenterChart" class="card coal-trend" :style="{ width: passGroupCenterChartWidth + 'px',height: passGroupCenterChartHeight + 'px'}"></div> -->
        <div class="card raw-coal-production">
          <div class="card-header">
            <h2><i class="icon blue"></i> 本中心入组</h2>
            <div class="time-filter">
              <button class="active" @click="selectCenter">切换中心</button>
            </div>
          </div>
     
          <div class="production-data">
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><Calendar />
              </el-icon>   -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#1890ff">
                  <path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14zm-2-2H9v-2h6v2zm0-4H9v-2h6v2zm0-4H9v-2h6v2zm0-4H9v-2h6v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData2["yesterday_pass"]}}</div>
              <div class="data-label">昨日入组(人)</div>
              </div>
            </div>
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><Histogram /></el-icon> -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#52c41a">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData2["month_pass"]}}</div>
              <div class="data-label">当月入组(人)</div>
              </div>
            </div>
            <div class="data-item">
              <!-- <el-icon class="icon-prefix"><TrendCharts /></el-icon> -->
              <!-- <div class="icon-container">
              <svg class="icon-prefix" viewBox="0 0 24 24" width="24" height="24" fill="#ff4d4f">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2zm0-4H7V3h10v2z"/>
                </svg>
              </div> -->
              <div class="data-content">
              <div class="data-value">{{viewInfoData2["year_pass"]}}</div>
              <div class="data-label">总共入组(人)</div>
              </div>
            </div>
            
          </div>
          <div class="production-data">
            <div class="data-item">
             
              <div class="data-content">
              <div class="data-value">  <button :style="{ visibility:  'hidden' }"  >规章管理</button></div>
              </div>
            </div>
            <div class="data-item">
             
              <div class="data-content">
                <div class="data-value">  <button :style="{ visibility:  'hidden' }"   >重大事项</button></div>
              </div>
            </div>
            
          </div>

          <div class="production-data">
            <div class="data-item">
              <div class="data-content">
              <div class="data-value"> <h4>当前中心：{{this.currentCenter!=null?this.currentCenter.name:projectUserInfo.center_name}}</h4></div>
              </div>
            </div>
          </div>
          
        </div>
        <!-- <div class="card raw-coal-production">
          <div class="card-header">
            <h2><i class="icon blue"></i> 待办事项</h2>
          </div>
          <div class="production-data">
            <div class="data-item">
             
              <div class="data-content">
              <div class="data-value">{{viewInfoData["not_handle_question"]}}</div>
              <div class="data-label">质疑待处理</div>
              </div>
            </div>
            <div class="data-item">
             
              <div class="data-content">
              <div class="data-value">{{viewInfoData["not_audit_form"]}}</div>
              <div class="data-label">表单待审核</div>
              </div>
            </div>
            <div class="data-item">
             
              <div class="data-content">
              <div class="data-value">{{viewInfoData["three_day_expired"]}}</div>
              <div class="data-label">3天过期表单</div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="card raw-coal-production">
          <div class="card-header">
            <h2><i class="icon blue"></i> 本中心质控与人员</h2>
          </div>
          <div class="progress-list">
            <div class="progress-item">
              <!-- <div class="progress-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#1890ff">
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                </svg>
              </div> -->
              <div class="progress-content">
                <div class="progress-label"><span> <a-tooltip class="info-row" >应答率
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip></span></div>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{width: (groupRateData.totalCount &lt;= 0?0:(groupRateData.passCount/groupRateData.totalCount*100).toFixed(1))+'%'}"></div>
                </div>
                <div class="progress-info">
                  <span class="progress-value">{{groupRateData.passCount}} / {{groupRateData.totalCount}}</span>
                  <span class="progress-percent">{{groupRateData.totalCount &lt;= 0?0:(groupRateData.passCount/groupRateData.totalCount*100).toFixed(1)}}%</span>
                </div>
              </div>
            </div>
            <div class="progress-item">
              <!-- <div class="progress-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#52c41a">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div> -->
              <div class="progress-content" title="点击查看周期随访率" @click="periodRate(groupRateData.centerId,1)">
                <div class="progress-label"><span><a-tooltip class="info-row" >随访率<template slot="title">
                  随访率=(提交的表单总数-失访提交的表单数)/(提交的表单总数)
              </template>
              <a-icon type="question-circle" /></a-tooltip></span></div>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{width: (groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.loseCount)/groupRateData.submitCount*100).toFixed(1))+'%'}"></div>
                </div>
                <div class="progress-info">
                  <span class="progress-value">{{groupRateData.submitCount-groupRateData.loseCount}} / {{groupRateData.submitCount}}</span>
                  <span class="progress-percent">{{groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.loseCount)/groupRateData.submitCount*100).toFixed(1)}}%</span>
                </div>
              </div>
            </div>
            <div class="progress-item">
              <!-- <div class="progress-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#faad14">
  <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-2-8h4v2h-4v-2zm0-4h4v2h-4v-2zm0-4h4v2h-4v-2z"/>
</svg>
              </div> -->
              <div class="progress-content" title="点击查看周期合格率" @click="periodRate(groupRateData.centerId,2)">
                <div class="progress-label"><span><a-tooltip class="info-row" >合格率<template slot="title">
                  合格率=(该周期提交表单总数-有效质疑数)/该周期提交表单总数
              </template>
              <a-icon type="question-circle" /></a-tooltip></span></div>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{width: (groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.questionCount)/groupRateData.submitCount*100).toFixed(1))+'%'}"></div>
                </div>
                <div class="progress-info">
                  <span class="progress-value">{{groupRateData.submitCount-groupRateData.questionCount}} / {{groupRateData.submitCount}}</span>
                  <span class="progress-percent">{{groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.questionCount)/groupRateData.submitCount*100).toFixed(1)}}%</span>
                </div>
              </div>
            </div>
            <div class="progress-item">
              <!-- <div class="progress-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="#ff4d4f">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"/>
                </svg>
              </div> -->
              <div class="progress-content" title="点击查看周期时效率" @click="periodRate(groupRateData.centerId,3)">
                <div class="progress-label"><span><a-tooltip class="info-row" >时效率<template slot="title">
                  时效率=(该周期提交表单总数-超时提交的表单数)/(提交的表单总数)
              </template>
              <a-icon type="question-circle" /></a-tooltip></span></div>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{width: (groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.delayCount)/groupRateData.submitCount*100).toFixed(1))+'%'}"></div>
                </div>
                <div class="progress-info">
                  <span class="progress-value">{{groupRateData.submitCount-groupRateData.delayCount}} / {{groupRateData.submitCount}}</span>
                  <span class="progress-percent">{{groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.delayCount)/groupRateData.submitCount*100).toFixed(1)}}%</span>
                </div>
              </div>
            </div>
            <div class="progress-item">
              <!-- <div class="progress-icon">
                <svg viewBox="0 0 24 24" fill="#4CAF50" width="24" height="24">  
                   环形进度条
                  <path d="M12 5a7 7 0 1 0 0 14 7 7 0 0 0 0-14" opacity="0.2"/>                  
                  勾号
                  <path d="M10.5 15.8l-3.2-3.2 1.4-1.4 1.8 1.8 4.2-4.2 1.4 1.4-5.6 5.6z"/>
                </svg>
              </div> -->
              <div class="progress-content" title="点击查看周期完整率" @click="periodRate(groupRateData.centerId,4)">
                <div class="progress-label"><span><a-tooltip class="info-row" >完整率<template slot="title">
                  完整率=(该周期提交表单总数-数据缺失提交的表单数)/(提交的表单总数)
              </template>
              <a-icon type="question-circle" /></a-tooltip></span></div>
                <div class="progress-bar">
                  <div class="progress-fill" :style="{width: (groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.missCount)/groupRateData.submitCount*100).toFixed(1))+'%'}"></div>
                </div>
                <div class="progress-info">
                  <span class="progress-value">{{groupRateData.submitCount-groupRateData.missCount}} / {{groupRateData.submitCount}}</span>
                  <span class="progress-percent">{{groupRateData.submitCount==0?0:((groupRateData.submitCount-groupRateData.missCount)/groupRateData.submitCount*100).toFixed(1)}}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>           
      </div>
      
      <div class="middle-column">
        <div class="card product-coal-trend" ref="monthEnrollChart" :style="{ width: passGroupCenterChartWidth + 'px',height: '426px'}"></div>   
        <div class="card coal-weight-analysis" ref="passGroupSexChart" :style="{ width: passGroupCenterChartWidth + 'px',height: '249px'}"></div>     
       
        <div class="card">
          <a-card title="项目成员" style="text-align: center;width: 100%">
            <div style="text-align: left;font-size: 20px;">
              <div class="progress-label" v-if="projectUserInfo.piUser"><span style="font-size: 20px;">PI：{{projectUserInfo.piUser}}</span></div>
              <div class="progress-label" v-if="projectUserInfo.centerUser"><span style="font-size: 20px;">中心管理员：{{projectUserInfo.centerUser}}</span></div>
              <div class="progress-label" v-if="projectUserInfo.manageUser"><span style="font-size: 20px;">项目管理员：{{projectUserInfo.manageUser}}</span></div>
              <div class="progress-label" v-if="projectUserInfo.dataUser"><span style="font-size: 20px;">数据管理员：{{projectUserInfo.dataUser}}</span></div>
              <div class="progress-label" v-if="projectUserInfo.checkUser"><span style="font-size: 20px;">数据审核员：{{projectUserInfo.checkUser}}</span></div>
              <div class="progress-label" v-if="projectUserInfo.gatherUser"><span style="font-size: 20px;">调查员：{{projectUserInfo.gatherUser}}人</span></div>
            </div>
          </a-card>
        </div>
       

      </div>
      <div class="right-column">
        <!-- <div class="card welcome">
          <h2>您好，{{nickname()}}，欢迎登录本系统</h2>
          <h2>所处中心：{{this.currentCenter!=null?this.currentCenter.name:projectUserInfo.center_name}}</h2>
          <h2>您的角色： {{projectUserInfo.role_name}}</h2>
        </div> -->
        <div class="card product-coal-trend" ref="periodRateChart" :style="{ width: passGroupCenterChartWidth+'px',height: '426px'}"></div>  
       
        <div class="card plan-completion" ref="passGroupAgeChart" :style="{ width: passGroupCenterChartWidth + 'px',height:  '249px'}"></div>
        <div class="card">
          <a-card title="调查员工作量统计" style="text-align: center;width: 100%;padding: 0px">
            <div>
        <a-table
          ref="table"
          size="middle"
          rowKey="resultid"
          :columns="columns"
          :dataSource="dataSource"
          :scroll="{x:`${width}`,y:'calc(25vh)'}"
          :pagination="false"
          :loading="loading"
          >
          <span slot="baselineRepRate">
            基线应答率
            <!-- <a-tooltip class="info-row" >
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip> -->
          </span>
          <span slot="periodNum">
            随访完成量
            <a-tooltip class="info-row" >
              <template slot="title">
                动态随访完成量：本月该调查员提交的随访人数/本月系统随机分配给该调查员的随访人数（%）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </span>
        </a-table>
      </div>
          </a-card>
        </div>
       
        <!-- <div class="card">
          <h2><i class="icon blue"></i> 通知公告</h2>
          <a-card title="公告栏" style="width: 100%">
            <div slot="extra" >
              <a-button type="link" @click="newNotice()">新增公告</a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="noticeReadAll()">全部标记已读</a-button>
            </div>
            <div class="notice-panel">
              <p style="width: 100%;" class="notice"  v-for="(item,index) in noticeList" :key="index" @click="viewNotice(item)">
                <label class="notice" :class="item.userIds && item.userIds.indexOf(userInfo().id)>=0?'':'no-read'">{{item.title}}</label>
                <label class="notice notice-time" :class="item.userIds && item.userIds.indexOf(userInfo().id)>=0?'':'no-read'">{{item.createTime}}</label>
              </p>
            </div>
          </a-card>
        </div> -->
      </div>
    </div>
    <!-- <a-modal
        title="新增公告"
        :width="1000"
        :visible="noticeVisible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="关闭">

        <a-spin :spinning="confirmLoading">
          <a-form-model layout="horizontal" ref="noticeForm" :rules="rules" :model="noticeForm" v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }">
            <a-form-model-item label="标题" prop="title">
              <a-input  v-model="noticeForm.title" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item label="内容" prop="content">
              <a-textarea :rows="6" v-model="noticeForm.content" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item label="上传文件">
              <a-upload name="file"  :multiple="false"
                        :headers="tokenHeader" :data="{biz:'/project/'+projectId+'/'+fileType+'/'+new Date().getTime()}" :action="importExcelUrl" @change="handleUploadChange">
                <a-button type="primary" icon="import">上传文件</a-button>
              </a-upload>
            </a-form-model-item>
          </a-form-model>
        </a-spin>
      </a-modal> -->
      <!-- <a-modal
        title="公告"
        :width="1000"
        :visible="noticeViewVisible"
        @cancel="noticeViewVisible = false"
        :footer="null">
        <div style="text-align: center;font-size: 24px">
          {{noticeForm.title}}
        </div>
        <div style="font-size: 18px;margin-top: 20px;margin-bottom: 20px">
          {{noticeForm.content}}
        </div>
        <div>
          <p v-for="(file,index) in noticeForm.fileList" :key="index">
            {{file}}<a-button type="link" @click="downloadFileHandle(index)">下载</a-button>
          </p>
        </div>
      </a-modal> -->
    <a-modal
      title="中心切换"
      :width="300"
      :visible="select_visible"
      :confirmLoading="confirmLoading"
      switchFullscreen
      @ok="selectCenterOk"
      @cancel="select_visible = false"
      cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal">
          <a-form-model-item>          
            <a-select placeholder="请选择中心" v-model="currentCenterId" style="width: 200px" allowClear>
                <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-modal
      :title="periodRateName"
      :visible="periodDetailVisible"
      @ok="periodDetailVisible=false"
      @cancel="periodDetailVisible=false"
      :cancelButtonProps="{ style: { display: 'none' } }"
      :okButtonProps="{ style: { display: 'none' } }">
      <div ref="periodChart" class="card coal-trend" style="width:460px; height:290px;"></div>
    </a-modal>
     </div>
     
</template>

<script>
  import ProjectStatus from '@/views/management/project/projectList/ProjectStatus'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import Vue from 'vue'
  import moment from 'moment'
  import {  mapGetters } from 'vuex'
  import CPie from './components/CPie'
  import { getAction ,postAction,downloadFile} from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import * as echarts from 'echarts'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'

  export default {
    name: 'Overview',
    mixins:[JeecgListMixin],
    components: { CPie,ProjectStatus},
    inject: ['viewInfoFn'],
    data() {
      return {
        columns: [],
        width:100,
        dataSource:[],
        rules:{
          title:[baseRules.required],
          content:[baseRules.required],
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileType:'5',
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        noticeVisible:false,
        noticeViewVisible: false,
        confirmLoading:false,
        marks: {
          0: '0%',
          50:'50%',
          100: '100%',
        },
        progressValue:20,
        data:[
          { item: '事例一', count: 40 },
          { item: '事例二', count: 21 },
        ],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        noticeForm:{
          files:''
        },
        defaultFileList:[{
          uid: '2',
          name: 'yyy.png',
          status: 'done',
          url: 'http://www.baidu.com/yyy.png',
        }],
        inited:false,
        project:{},
        viewInfoData1:{},
        viewInfoData2:{},
        infoList:{},
        progressList:[],
        progressColorList:['rgba(19,183,197,0.9)','rgba(245,115,41,0.9)','rgba(58,124,253,0.9)'],
        projectUserInfo:{
          roleList:[]
        },
        noticeList:[],
        passGroupCenterChart: null,
        passGroupSexChart: null,
        passGroupAgeChart: null,
        periodRateChart: null,
        monthEnrollChart:null,
        passGroupCenterChartWidth: "30vw",  // 30%  宽度
        passGroupCenterChartHeight: 384,
        groupRateData: {},
        groupAgeData:[],
        select_visible:false,
        currentCenterId:undefined,
        currentCenter:null,
        centerList: [],        
        queryParam: {},
        disableMixinCreated: true,
        periodDetailVisible: false,
        periodChart: null,
        periodRateName: '详细信息',
      }
    },
    created() {
      this.inited = false //处理项目当前进度变形
      this.$nextTick(()=>{
        this.inited=true
      })
      this.queryParam.projectId = this.projectId      
      this.loadProject()
      this.loadColumn()
    },
    computed: {
      importExcelUrl() {
        return `${window._CONFIG['domianURL']}/sys/common/upload`
      },
      groupAgeDataTotal(){
        return this.groupAgeData.reduce((sum, item) => sum + item.count, 0);
      },
    },
    methods: {
      async loadColumn(){
        // 添加 周期的column
        const columns = [
          {
            title: '调查员',
            align:"center",
            width: 100,
            dataIndex: 'personName'
          },
         
          {
            title: '基线提交人数',
            align:"center",
            width: 100,
            dataIndex: 'baselineSubmitNum'
          },
         {
            // title: '基线应答率统计',
            slots: { title: 'baselineRepRate' },
            align:"center",
            width: 100,
            dataIndex: 'baselineRepRate'
          }
         
        ]
        columns.push({
          title: '随访数量总计',
          width: 100,
          align:"center",
          dataIndex: 'periodSum'
        })       
        this.width = 800 
        this.columns = columns
      },
      loadNotice(){
        getAction('/project/projectNotice/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.noticeList=res.result
          }
        })
      },
      getCenterList(){
        getAction('/project/center/auth_center',{projectId:this.projectId}).then(res=>{
          if(res.success && res.result){
            this.centerList = res.result
          }else{
            this.$message.error('后台请求异常')
          }
        })
      },
      selectCenterOk(){
        console.log("this.currentCenterId："+this.currentCenterId)
        if(this.currentCenterId){
          this.currentCenter = this.centerList.find(c=>c.id === this.currentCenterId)          
          this.loadProject(this.currentCenterId)
        }else{
          // this.currentCenter = null
          // this.loadView()
        } 
        this.select_visible = false      
      },
      loadProject(centerId){
        // this.loadNotice()
        getAction('/management/project/projectUserInfo',{id:this.projectId,centerId:centerId}).then(res=>{
          if(res.success){
            this.projectUserInfo=res.result
            console.log("this.projectUserInfo:"+this.projectUserInfo)
            this.loadView(centerId?centerId:this.projectUserInfo.centerId)
          }
        })
      },

      loadView(centerId){        
        console.log("centerId:"+centerId)
        
        getAction('/management/project/getViewInfo',{projectId:this.projectId,row:1}).then(res=>{
          if(res.success){
            this.viewInfoData1 = res.result            
          }
        })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:1}).then(res=>{
          if(res.success){
            this.viewInfoData2 = res.result            
          }
        })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,row:2}).then(res=>{
          if(res.success){
            this.initPassGroupCenterChart(res.result["pass_group_center"])
          }
        })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,row:3}).then(res=>{
          if(res.success){
            this.initMonthEnrollCharts(res.result["pass_group_center_month"])
          }
        })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,row:4}).then(res=>{
          if(res.success){            
            this.initPeriodRateChart(res.result["center_form_rate"])
          }
        })  
        getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:5}).then(res=>{
          if(res.success){            
            this.initGroupSexChart(res.result["pass_sex_center"])
            // this.initGroupAgeChart(res.result["pass_age_center"])  
          }
        })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:6}).then(res=>{
          if(res.success){   
            this.groupAgeData = res.result["pass_age_center"]    
            this.initGroupAgeChart(res.result["pass_age_center"])          
          }
        })
        // getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:9}).then(res=>{
        //   if(res.success){
        //     this.initGroupAgeChart2(res.result["all_age_center"])
        //   }
        // })
        getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:7}).then(res=>{
          if(res.success){                        
            this.groupRateData = res.result["rate_center"]
          }
        })
        this.queryParam.projectId = this.projectId
        this.queryParam.centerId = centerId
        getAction('/project/statistic/workload',this.queryParam).then(res=>{
          if(res.success){
            this.dataSource = res.result.records || res.result;
          }
        })
      },
      periodRate(centerId,type){
        this.periodDetailVisible = true
        if(type ==1) this.periodRateName ='随访率'
        else if (type ==2) this.periodRateName ='合格率'
        else if (type ==3) this.periodRateName ='时效率'
        else if (type ==4) this.periodRateName ='完整率'
        getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:8}).then(res=>{
          if(res.success){
            this.initPeriodCharts(res.result["period_rate_center"],type)
          }
        })
      },
      selectCenter(){
        this.getCenterList()
        this.select_visible = true
      },
      ...mapGetters(["nickname","userInfo"]),
      nowTime(){
        return  moment().format('YYYY-MM-DD HH:mm:ss')
      },
      newNotice(){
        this.noticeForm = {}
        this.noticeVisible =true
      },
      handleOk(){
        this.$refs.noticeForm.validate(valid  => {
          if(valid){
            this.confirmLoading =true
            this.noticeForm.projectId = this.projectId
            postAction('/project/projectNotice/saveOrUpdate',this.noticeForm).then(res=>{
              if(res.success){
                this.loadNotice()
                this.handleCancel()
              }
            }).finally(()=>{
              this.confirmLoading =false
            })
          }
        })
      },
      noticeReadAll(){
        postAction('/project/projectNotice/noticeReadAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.loadNotice()
          }
        }).finally(()=>{
        })
      },
      handleCancel(){
        this.noticeVisible =false
      },
      viewNotice(record){
        record.fileList = record.files?record.files.split(','):[]
        record.pathList = record.paths?record.paths.split(','):[]
        this.noticeForm = record
        this.noticeViewVisible =true
        postAction('/project/projectNotice/read',{id:record.id}).then(res=>{
          if(res.success){
            this.loadNotice()
          }
        }).finally(()=>{
        })
      },
      viewInfo(){
          this.viewInfoFn()
      },
      downloadFileHandle(index){
        downloadFile('/sys/common/static'+this.noticeForm.pathList[index],this.noticeForm.fileList[index])
      },
      handleUploadChange(info) {
        // if (info.file.status !== 'uploading') {
        //   console.log(info.file, info.fileList);
        // }
        if (info.file.status === 'done' || info.file.status === 'removed') {
          let paths = ''
          let files = ''
          if(info.fileList){
            info.fileList.forEach(item=>{
              if(paths){
                paths +=','+ item.response.message
                files +=','+ item.name
              }else{
                paths = item.response.message
                files = item.name
              }
            })
          }
          this.$set(this.noticeForm,'paths',paths);
          this.$set(this.noticeForm,'files',files);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      },
      
    showDetailChart(hospitalName) {
      this.showDetail = true;
      this.$nextTick(() => {
        //if (!this.detailChartInstance) {
          this.detailChartInstance = echarts.init(this.$refs.detailChart);
        //}

        this.detailChartInstance.setOption({
          title: {
            text: `${hospitalName} 门诊量`,
            left: 'center',
            top: 20
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: [hospitalName]
          },
          yAxis: {
            type: 'value',
            name: '单位：人次'
          },
          series: [{
            name: '门诊量',
            type: 'bar',
            data: [this.outpatientData[hospitalName]],
            barWidth: 40,
            itemStyle: { color: '#3F51B5' },
            label: { show: true, position: 'top', formatter: '{c}' }
          }]
        });
      });
    },
    closeDetail() {
      this.showDetail = false;
    },
    initMonthEnrollCharts(data){      

      if(!data) return
      var centers = Object.keys(data)
      var months = data[centers[0]].map(d => d.month)
      var seriesData = centers.map(center => {
        return {
          name: center,
          type: 'line',
          //stack: '人数',
          data: data[center].map(d => d.count===0?null:d.count),
        }
      })

      this.monthEnrollChart = echarts.init(this.$refs.monthEnrollChart);
      this.monthEnrollChart.setOption({
        title: {
    text: '{circle|}\入组趋势统计',
    left: 'center',
            textStyle: {
              rich: {
                circle: {
                  backgroundColor: '#1890ff', // 圆点颜色
                  width: 12,                   // 圆点宽度
                  height: 12,                  // 圆点高度
                  borderRadius: 6,            // 圆角半径（设为50%为圆形）
                  verticalAlign: 'middle'      // 垂直对齐方式
                }
              },
              fontWeight: 'normal', // 取消加粗
              fontSize: 16,
              color: '#333',
              padding: [0, 0, 0, 10] // 左留白控制圆点位置
            }
  },
  tooltip: {
    trigger: 'axis'
  },  
  legend: {          
          data: centers.map(item => ({
            name: item,
            tooltip: {
              formatter: item
            }
          })),
          bottom: 10,
          left: 'center',
          formatter: function (name) {
            // 截取前几个字符
            if(centers.length > 3 && centers.length < 9){
              return name.length > 4 ? name.slice(0, 4) + '..' : name;
            }else if(centers.length >= 9){
              return '';
            }
            return name;
          },
          tooltip: {
            show: true
          }
        },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '60',
    containLabel: true
  },
  // toolbox: {
  //   feature: {
  //     saveAsImage: {}
  //   }
  // },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: months
  },
  yAxis: {
    type: 'value'
  },
  series: seriesData
  // series: [    
  //   {
  //     name: 'Email',
  //     type: 'line',
  //     stack: 'Total',
  //     data: [120, 132, 101, 134, 90, 230, 210]
  //   },
  //   {
  //     name: 'Union Ads',
  //     type: 'line',
  //     stack: 'Total',
  //     data: [220, 182, 191, 234, 290, 330, 310]
  //   },
  //   {
  //     name: 'Video Ads',
  //     type: 'line',
  //     stack: 'Total',
  //     data: [150, 232, 201, 154, 190, 330, 410]
  //   }
  // ]
      });
    },
    initPeriodCharts(data,type){
      if(!data) return
      // var centers = Object.keys(data)
      // var months = data[centers[0]].map(d => d.month)
      // var seriesData = centers.map(center => {
      //   return {
      //     name: center,
      //     type: 'line',
      //     //stack: '人数',
      //     data: data[center].map(d => d.count)
      //   }
      // })
      var rateData = []
      var periodNames = []
      var ymin = 0
      var ymax = 100;
      if(type ==1 ){
        periodNames = data.filter(d=>d.submitRate>0).map(d => d.periodName)
        rateData = data.filter(d=>d.submitRate>0).map(d => d.submitRate)
      }else if(type ==2 ){
        periodNames = data.filter(d=>d.noQuestionRate>0).map(d => d.periodName)
        rateData = data.filter(d=>d.noQuestionRate>0).map(d => d.noQuestionRate)
      }else if(type ==3 ){
        periodNames = data.filter(d=>d.delayRate>0).map(d => d.periodName)
        rateData = data.filter(d=>d.delayRate>0).map(d => d.delayRate)
      }else if(type ==4 ){
        periodNames = data.filter(d=>d.missRate>0).map(d => d.periodName)
        rateData = data.filter(d=>d.missRate>0).map(d => d.missRate)
      }
      ymin = Math.min(...rateData)
      ymax = Math.max(...rateData)
      ymin = ymin-1 < 0 ?0:ymin-1
      ymax = ymax+1 > 100 ?100:ymax+1

      this.periodChart = echarts.init(this.$refs.periodChart);
      
      // 配置项
        const option = {
          // title: {            
          //   text: '{circle|}\t应答率/随访率统计', // \t 用于添加间隔
          //   textStyle: {
          //     rich: {
          //       circle: {
          //         backgroundColor: '#52c41a', // 圆点颜色
          //         width: 12,                   // 圆点宽度
          //         height: 12,                  // 圆点高度
          //         borderRadius: 6,            // 圆角半径（设为50%为圆形）
          //         verticalAlign: 'middle'      // 垂直对齐方式
          //       }
          //     },
          //     fontWeight: 'normal', // 取消加粗
          //     fontSize: 16,
          //     color: '#333',
          //     padding: [0, 0, 0, 10] // 左留白控制圆点位置
          //   }
          // }, 
          tooltip: {
            trigger: 'item'
          }, 
          grid: { top: 10, left: '5%', right: '5%', bottom: 10, containLabel: true },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: periodNames,
            // axisLabel: {
            //     rotate: 45,          // 文字旋转角度              
            //     formatter: (value) => {  // 超长文字截断
            //       return value.length > 10 ? value.slice(0,10)+'...' : value;
            //     },
            //     padding: [0, 0, 0, 20], // 左方向增加 20px 边距
            //     align: 'middle' // 文字左对齐
            //   },
          },
          yAxis: {
            type: 'value',
            name: '单位：%',
            nameGap: 25,
            axisLabel: {
              align: 'right' // 将标签向左侧对齐
            },
            min: ymin, // 设置 Y 轴最小值
            max: ymax, // 设置 Y 轴最大值
          },
          series: [
            {
              data: rateData,
              type: 'line',
              areaStyle: {color: 'rgba(24, 144, 255, 0.1)'},
              lineStyle: {
                color: '#1890ff'
              },
            }
          ]
        };
        // 设置配置项并渲染图表
        this.periodChart.setOption(option);

        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.periodChart.resize();
        });
    },
    initPassGroupCenterChart(data) {      
        // this.passGroupCenterChartWidth = (window.screen.width-200)/3
        // this.passGroupCenterChartHeight = (window.screen.height-100)/3
        // 初始化图表实例
        this.passGroupCenterChart = echarts.init(this.$refs.passGroupCenterChart);
        // console.log(data)

      this.passGroupCenterChart.setOption({
                 title: {            
            text: '{circle|}\t各中心入组统计', // \t 用于添加间隔
            left: 'center',
                  textStyle: {
                    rich: {
                      circle: {
                        backgroundColor: '#1890ff', // 圆点颜色
                        width: 12,                   // 圆点宽度
                        height: 12,                  // 圆点高度
                        borderRadius: 6,            // 圆角半径（设为50%为圆形）
                        verticalAlign: 'middle'      // 垂直对齐方式
                      }
                    },
                    fontWeight: 'normal', // 取消加粗
                    fontSize: 16,
                    color: '#333',
                    padding: [0, 0, 0, 10] // 左留白控制圆点位置
                  }
          },
          // grid: {
          //   top: 80, // 图表区域距离容器顶部 80px
          // },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: {          
          data: data.map(item => ({
            name: item.centerName,
            tooltip: {
              formatter: item.centerName
            }
          })),
          bottom: 10,
          left: 'center',
          formatter: function (name) {
            // 截取前几个字符
            if(data.length > 3 && data.length < 9){
              return name.length > 4 ? name.slice(0, 4) + '..' : name;
            }else if(data.length >= 9){
              return '';
            }
            return name;
          },
          tooltip: {
            show: true
          }
        },
        grid: { top: 80, left: '10%', right: '10%', bottom: 60, containLabel: true },
        xAxis: { type: 'category', data: [''] },
        yAxis: { type: 'value', name: '单位：人' },
        series: data.map(item => ({
          name: item.centerName,
          type: 'bar',
          data: [item.count],
          barWidth: 30,
          barMinHeight: 10,  // 最小高度
          itemStyle: { color: item.color },
          label: { show: true, position: 'top', formatter: '{c}' }
        }))
      });

      this.passGroupCenterChart.on('click', params => {
        if (this.outpatientData[params.seriesName]) {
          this.showDetailChart(params.seriesName);
        }
      });

        // var xaxisData = data.map(item => item.centerName)
        // var yaxisData = data.map(item => item.count)

        // // 配置项
        // const option = {
        //   title: {            
        //     text: '{circle|}\t中心入组统计', // \t 用于添加间隔
        //     textStyle: {
        //       rich: {
        //         circle: {
        //           backgroundColor: '#1890ff', // 圆点颜色
        //           width: 12,                   // 圆点宽度
        //           height: 12,                  // 圆点高度
        //           borderRadius: 6,            // 圆角半径（设为50%为圆形）
        //           verticalAlign: 'middle'      // 垂直对齐方式
        //         }
        //       },
        //       fontWeight: 'normal', // 取消加粗
        //       fontSize: 16,
        //       color: '#333',
        //       padding: [0, 0, 0, 10] // 左留白控制圆点位置
        //     }
        //   },
        //   grid: {
        //     top: 80, // 图表区域距离容器顶部 80px
        //   },
        //   tooltip: {},
        //   xAxis: {
        //     type: 'category',
        //     data: xaxisData,
        //     // axisLabel: {
        //     //   show: false,
        //     //   rotate: 45,          // 文字旋转角度              
        //     //   formatter: (value) => {  // 超长文字截断
        //     //     return value.length > 10 ? value.slice(0,10)+'...' : value;
        //     //   },
        //     //   padding: [0, 0, 0, 20], // 左方向增加 20px 边距
        //     //   align: 'middle' // 文字左对齐
        //     // },
        //     z:10,
        //   },
        //   yAxis: {
        //     type: 'value',
        //     name: '单位：人',
        //         nameGap: 20,
        //         axisLabel: {
        //             align: 'left' // 将标签向左侧对齐
        //         }
        //   },
        //   series: [{
        //     name: '入组人数',
        //     type: 'bar',
        //     barWidth: 20,
        //     data: yaxisData,
        //     itemStyle: {
        //       color: '#1890ff' // 自定义柱状图颜色
        //     },
        //     z:1,
        //   }],
        // };

        // // 设置配置项并渲染图表
        // this.passGroupCenterChart.setOption(option);

        // // 窗口变化时自适应
        // window.addEventListener('resize', () => {
        //   this.passGroupCenterChart.resize();
        // });
      },
      initGroupSexChart(data) {
        // 初始化图表实例
        this.passGroupSexChart = echarts.init(this.$refs.passGroupSexChart);
        // console.log(data)
        var playData = []
        data.forEach(item=>{
          playData.push({ value: item.count, name: item.centerName })
        })        

        // 配置项
        const option = {
          color: ['#52c41a', '#1890ff', '#faad14'],
          title: {            
            text: '{circle|}\t受试者性别统计', // \t 用于添加间隔
            left: 'center',
            textStyle: {
              rich: {
                circle: {
                  backgroundColor: '#1890ff', // 圆点颜色
                  width: 12,                   // 圆点宽度
                  height: 12,                  // 圆点高度
                  borderRadius: 6,            // 圆角半径（设为50%为圆形）
                  verticalAlign: 'middle'      // 垂直对齐方式
                }
              },
              fontWeight: 'normal', // 取消加粗
              fontSize: 16,
              color: '#333',
              padding: [0, 0, 0, 10] // 左留白控制圆点位置
            }
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            bottom: 10,
                      textStyle: {
                           color: '#333',
                          fontSize: 14
          }
          },
          series: [
            {
              name: '性别人数',
              type: 'pie',
              radius: '50%',
              data: playData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        // 设置配置项并渲染图表
        this.passGroupSexChart.setOption(option);

        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.passGroupSexChart.resize();
        });
      },
      initGroupAgeChart(data) {
        // 初始化图表实例
        this.passGroupAgeChart = echarts.init(this.$refs.passGroupAgeChart);
         console.log(11,data)
        var actualData = []
        var playData = []
        var totalValue = 0
        var names = []
        data.forEach(item=>{
          actualData.push(item.count)
          names.push(item.centerName)
          playData.push({ value: item.count, name: item.centerName })
          totalValue += item.count
        })  
       
      
        //console.log(totalValue)   
        const option={
               title: {            
                  text: '{circle|}\t受试者年龄统计', // \t 用于添加间隔
                  left: 'center',
                  textStyle: {
                    rich: {
                      circle: {
                        backgroundColor: '#1890ff', // 圆点颜色
                        width: 12,                   // 圆点宽度
                        height: 12,                  // 圆点高度
                        borderRadius: 6,            // 圆角半径（设为50%为圆形）
                        verticalAlign: 'middle'      // 垂直对齐方式
                      }
                    },
                    fontWeight: 'normal', // 取消加粗
                    fontSize: 16,
                    color: '#333',
                    padding: [0, 0, 0, 10] // 左留白控制圆点位置
                  }
                },
                 tooltip: {
                      trigger: 'item'
                    },
                    legend: {
                     
                      bottom: 10,
                      textStyle: {
                           color: '#333',
                          fontSize: 14
          }   
                    },
                  series: [
                      {
                        name: '年龄人数',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        padAngle: 5,
                        itemStyle: {
                          borderRadius: 10
                        },
                        label: {
                          show: false,
                          position: 'center'
                        },
                        emphasis: {
                          label: {
                            show: true,
                            fontSize: 40,
                            fontWeight: 'bold'
                          }
                        },
                        labelLine: {
                          show: false
                        },
                        data: playData
                      }
             ]}        
       
        // 设置配置项并渲染图表
        this.passGroupAgeChart.setOption(option);

        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.passGroupAgeChart.resize();
        });
      },
      initGroupAgeChart2(ages) {
        // 初始化图表实例
        this.passGroupAgeChart = echarts.init(this.$refs.passGroupAgeChart);
        // const ages = [10,50,30,66,79,86,22,35,26,16,67,87,90,32,50];

        // ---------- 关键参数计算 ----------
        // 1. 计算统计量
        const mean = ages.reduce((a,b) => a+b)/ages.length;  // 均值≈49.7
        const std = Math.sqrt( // 样本标准差≈26.2
            ages.map(x => (x-mean)**2).reduce((a,b)=>a+b)/(ages.length-1)
        );

        // 2. 直方图分箱（每10岁一组）
        const binSize = 10;
        const histogram = {};
        ages.forEach(age => {
            const bin = Math.floor(age/binSize)*binSize;
            histogram[bin] = (histogram[bin] || 0) + 1;
        });

        // 3. 正态曲线生成
        const curvePoints = [];
        const xStart = Math.min(...ages);    // X轴起点（向下扩展显示）
        const xEnd = Math.max(...ages);    // X轴终点（向上扩展显示）
        for(let x=xStart; x<=xEnd; x+=0.5) { // 0.5岁精度生成平滑曲线
            const y = (1/(std*Math.sqrt(2*Math.PI))) * 
                    Math.exp(-0.5*((x-mean)/std)**2) * 
                    ages.length * binSize; // 单位转换公式
            curvePoints.push([x, y]);
        }

        const option = {
            title: {            
                  text: '{circle|}\t受试者年龄统计', // \t 用于添加间隔
                  subtext: `均值=${mean.toFixed(1)}岁 | 标准差=${std.toFixed(1)}岁`, // 均值和标准差显示
                  left: 'center',
                  textStyle: {
                    rich: {
                      circle: {
                        backgroundColor: '#1890ff', // 圆点颜色
                        width: 12,                   // 圆点宽度
                        height: 12,                  // 圆点高度
                        borderRadius: 6,            // 圆角半径（设为50%为圆形）
                        verticalAlign: 'middle'      // 垂直对齐方式
                      }
                    },
                    fontWeight: 'normal', // 取消加粗
                    fontSize: 16,
                    color: '#333',
                    padding: [0, 0, 0, 10] // 左留白控制圆点位置
                  }
                },
            // tooltip: { trigger: 'axis' },
            // legend: { data: ['实际分布', '正态分布'] },
            tooltip: {
              trigger: 'axis',
              // 关键修改：自定义 Tooltip 数值格式
              formatter: function(params) {
                let tooltipContent = '年龄：'+params[0].axisValue.toFixed(0) + '岁<br/>';
                params.forEach(param => {
                  // 对数值进行取整处理
                  const value = Math.round(param.value[1]); 
                  tooltipContent += `
                    人数：${value}人
                  `;
                });
                return tooltipContent;
              }
            },
            // legend: {                     
            //           bottom: 10,
            //           textStyle: {
            //               //  color: '#333',
            //               fontSize: 14
            //           }   
            //         },
            grid: { left: '6%', right: '10%', bottom: 10, containLabel: true },
            xAxis: {
                name: '年龄',
                type: 'value',
                min: xStart,
                max: xEnd,
                axisLabel: { formatter: '{value}岁' }
            },
            yAxis: { name: '人数' },
            
            series: [
                // 直方图（柱状图）
                // {
                //     type: 'bar',
                //     name: '实际分布',
                //     data: Object.entries(histogram).map(([bin,count]) => ({
                //         value: [parseInt(bin)+binSize/2, count], // 柱子中点为区间中点
                //         itemStyle: { 
                //             color: '#91CC75',
                //             borderRadius: [3,3,0,0] // 顶部圆角
                //         }
                //     })),
                //     barWidth: binSize-2 // 留出间距
                // },
                // 正态曲线（折线图）
                {
                    type: 'line',
                    name: '正态分布',
                    data: curvePoints,
                    smooth: true,
                    lineStyle: { 
                        color: '#EE6666',
                        width: 3 
                    },
                    markLine: {
                      symbol: ['none', 'none'],
                      label: { show: false },
                      data: [{ xAxis: mean.toFixed(1) }]
                    },
                    symbol: 'none' // 隐藏数据点标记
                }
            ]
        };
       
        // 设置配置项并渲染图表
        this.passGroupAgeChart.setOption(option);

        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.passGroupAgeChart.resize();
        });
      },
      initPeriodRateChart(data){
        data=data.filter(item=>item.resRate!='0')
        var centers = data.map(d => d.centerName)
        const avgPeople = data.map(d => d.resRate)
        const seatRate = data.map(d => d.floRate)

        // 初始化图表实例
        this.periodRateChart = echarts.init(this.$refs.periodRateChart);
        // console.log(22,data) 
        // const years = ['2018', '2019', '2020', '2021', '2022', '2023', '2024'];
      

      this.periodRateChart.setOption({
          title: {            
            text: '{circle|}\t应答率/随访率统计', // \t 用于添加间隔
            left: 'center',
            textStyle: {
              rich: {
                circle: {
                  backgroundColor: '#1890ff', // 圆点颜色
                  width: 12,                   // 圆点宽度
                  height: 12,                  // 圆点高度
                  borderRadius: 6,            // 圆角半径（设为50%为圆形）
                  verticalAlign: 'middle'      // 垂直对齐方式
                }
              },
              fontWeight: 'normal', // 取消加粗
              fontSize: 16,
              color: '#333',
              padding: [0, 0, 0, 10] // 左留白控制圆点位置
            }
          }, 
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const index = params[0].dataIndex;
            return `
              ${centers[index]}<br/>
              应答率: ${avgPeople[index]} %<br/>
              随访率: ${seatRate[index]} %
            `;
          }
        },
        legend: {
          data: ['应答率', '随访率'],
          bottom: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: { left: '10%', right: '10%', bottom: 50, containLabel: true },
        xAxis: {
          type: 'value',
          min: -20,
          max: 20,
          splitLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: centers,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: value => `${value}`,
            color: '#333',
            fontSize: 14,
            margin: 40
          }
        },
        series: [
          {
            name: '应答率',
            type: 'bar',
            stack: 'total',
            data: avgPeople.map(item => -item),
            barWidth: 14,
            itemStyle: { color: '#FFC400' },
            label: {
              show: true,
              position: 'left',
              formatter: params => Math.abs(params.value)+'%',
              color: '#333'
            }
          },
          {
            name: '随访率',
            type: 'bar',
            stack: 'total',
            data: seatRate,
            barWidth: 14,
            itemStyle: { color: '#FF6D00' },
            label: {
              show: true,
              position: 'right',
              formatter: '{c} %',
              color: '#333'
            }
          }
        ]
      });
        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.periodRateChart.resize();
        });
      },      
    },
    beforeDestroy() {
      if (this.passGroupCenterChart) {
        window.removeEventListener('resize', this.passGroupCenterChart.resize);
        this.passGroupCenterChart.dispose();
      }
      if (this.passGroupSexChart) {
        window.removeEventListener('resize', this.passGroupSexChart.resize);
        this.passGroupSexChart.dispose();
      }
      if (this.passGroupAgeChart) {
        window.removeEventListener('resize', this.passGroupAgeChart.resize);
        this.passGroupAgeChart.dispose();
      }
      if (this.periodRateChart) {
        window.removeEventListener('resize', this.periodRateChart.resize);
        this.periodRateChart.dispose();
      }
    },
  }
</script>

<style scoped>
/* 原有样式保持不变 */

/* 原煤产量卡片样式 */
.icon-prefix {
  font-size: 24px;
  color: #1890ff;
  margin-bottom: 10px;
  /* stroke-width: 2;  */
}

.data-trend .el-icon {
  margin-right: 4px;
}

.raw-coal-production {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  padding: 20px;
}

.raw-coal-production .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.raw-coal-production .card-header h2 {
  font-size: 18px;
  color: #3710e6;
  margin: 0;
  text-decoration: underline;
}

.raw-coal-production .icon {
  display: inline-block;
  width: 4px;
  height: 16px;
  background-color: #1890ff;
  margin-right: 8px;
  vertical-align: middle;
}

.raw-coal-production .production-data {
  display: flex;
  justify-content: space-between;
}

.raw-coal-production .data-item {
  text-align: center;
  flex: 1;
}
.data-item {
  display: flex;
  align-items: center;
}

.icon-container {
  margin-right: 0px; /* 调整图标与内容之间的间距 */
}

.data-content {
  flex: 1;
}

.raw-coal-production .data-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.raw-coal-production .data-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.raw-coal-production .data-trend {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.raw-coal-production .data-trend.increase {
  color: #52c41a;
  background-color: rgba(82, 196, 26, 0.1);
}

.raw-coal-production .data-trend.decrease {
  color: #ff4d4f;
  background-color: rgba(255, 77, 79, 0.1);
}

.raw-coal-production .trend-icon {
  margin-right: 2px;
}


/* 图表共享样式 */
.coal-trend .chart-container,
.product-coal-trend .chart-container {
  display: flex;
  height: 300px;
  margin-top: 20px;
  padding-bottom: 20px;
}

.coal-trend .y-axis,
.product-coal-trend .y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  width: 60px;
}

.coal-trend .y-label,
.product-coal-trend .y-label {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-bottom: 10px;
}

.coal-trend .y-values,
.product-coal-trend .y-values {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: right;
  font-size: 12px;
  color: #666;
}

.coal-trend .chart-content,
.product-coal-trend .chart-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.coal-trend .x-axis,
.product-coal-trend .x-axis {
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.coal-trend .x-axis span,
.product-coal-trend .x-axis span {
  font-size: 12px;
  color: #999;
  transform: rotate(-45deg);
  transform-origin: top left;
  width: 10%;
  text-align: right;
}

/* 原煤产量趋势图表样式 */
.coal-trend .chart-container {
  display: flex;
  height: 300px;
  margin-top: 20px;
  padding-bottom: 20px;
}

.coal-trend .y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  width: 60px;
}

.coal-trend .y-label {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-bottom: 10px;
}

.coal-trend .y-values {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: right;
  font-size: 12px;
  color: #666;
}

.coal-trend .chart-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.coal-trend .bar-container {
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding-bottom: 10px;
  position: relative;
}

.coal-trend .bar {
  width: 4%;
  background-color: #1890ff;
  border-radius: 2px 2px 0 0;
  position: relative;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.coal-trend .bar:hover {
  background-color: #40a9ff;
}

.coal-trend .bar.highlighted {
  background-color: #52c41a;
}

.coal-trend .bar-value {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #666;
}

.coal-trend .highlight-dot {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 12px;
  background-color: #52c41a;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(0,0,0,0.2);
}

.coal-trend .x-axis {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.coal-trend .x-axis {
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.coal-trend .x-axis span {
  font-size: 12px;
  color: #999;
  transform: rotate(-45deg);
  transform-origin: top left;
  width: 10%;
  text-align: right;
}

.dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow: auto;
}

nav {
  display: flex;
}

nav a {
  margin: 0 10px;
  text-decoration: none;
  color: #333;
  padding: 5px 0;
}

nav a.active {
  color: #1890ff;
  border-bottom: 2px solid #1890ff;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-info span {
  margin-right: 10px;
}

.content {
  display: flex;
  flex: 1;
  padding: 20px;
  background-color: #f0f2f5;
  gap: 20px;
}

.left-column, .middle-column, .right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 30%;
}

.card {
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.card-header h2 {
  font-size: 16px;
  margin: 0;
  display: flex;
  align-items: center;
}

.icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.icon.blue {
  background-color: #1890ff;
}

.icon.green {
  background-color: #52c41a;
}

.icon.orange {
  background-color: #faad14;
}

.icon.purple {
  background-color: #722ED1;
}

.time-filter {
  display: flex;
}

.time-filter button {
  background: transparent;
  border: 1px solid #e8e8e8;
  padding: 2px 10px;
  cursor: pointer;
  font-size: 12px;
}

.time-filter button.active {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
}

.progress-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.progress-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.progress-content {
  flex-grow: 1;
  cursor: pointer;
}

.progress-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

.progress-bar {
  height: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-fill {
  height: 100%;
  background-color: #1890ff;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.progress-value {
  color: #666;
}

.progress-percent {
  color: #1890ff;
  font-weight: bold;
}

.welcome {
  background-color: #1890ff;
  color: white;
}
/* 煤炭加权分析图表样式 */
.coal-weight-analysis .pie-chart-container {
  display: flex;
  margin-top: 20px;
  height: 250px;
}

.coal-weight-analysis .pie-chart {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coal-weight-analysis .pie-chart svg {
  max-width: 200px;
  max-height: 200px;
}

.coal-weight-analysis .pie-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}

.coal-weight-analysis .legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.coal-weight-analysis .legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 8px;
}

.coal-weight-analysis .legend-label {
  width: 50px;
  color: #333;
}

.coal-weight-analysis .legend-value {
  width: 80px;
  color: #666;
}

.coal-weight-analysis .legend-percent {
  font-weight: bold;
}

/* 商品煤产量趋势图表样式 */
.product-coal-trend .line-chart {
  position: relative;
  height: 100%;
  width: 100%;
}

.product-coal-trend .line-chart svg {
  width: 100%;
  height: 100%;
}

.product-coal-trend .data-labels {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.product-coal-trend .data-labels span {
  position: absolute;
  transform: translate(-50%, -20px);
  font-size: 12px;
  color: #666;
}

.product-coal-trend .data-labels span.highlighted {
  color: #52c41a;
  font-weight: bold;
}
</style>
